var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { get, isEmpty } from 'lodash';
import cx from 'classnames';
import StringWidget from 'components/StringWidget';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import { CartItemState } from '@rome/response/cart/enums/CartItemState';
import { PickupCharge } from 'components/CartItem/PickupCharge';
import { PriceType } from '@rome/response/transact/PriceType';
import { CartItemCardPriceInfo } from 'components/CartItem/CartItemCardPriceInfo';
import CartOffer from 'components/CartItem/CartOffer/CartOffer';
import { KnowMoreContent } from './BuyBackTnC';
import Help from 'components/Help/Help';
import PlusPrice from 'components/PriceWidget/PlusPrice';
import omnitureHelper from 'utils/omnitureHelper';
import placeholder from 'images/placeholder.svg';
import removeIcn from 'images/remove.svg';
import styles from './ChildItems.css';
const trackHelpOpen = (isActive) => {
    const pageName = 'View Cart';
    const pageType = 'Cart';
    if (!isActive)
        return;
    omnitureHelper.trackLink({
        prop3: pageType,
        prop4: pageName
    }, 'Cart: Read all check');
};
export const hasChildItems = (cartItem) => {
    if (!cartItem)
        return false;
    const { childItems } = cartItem;
    return childItems && childItems.length;
};
export var CHILD_ITEM_TYPE_LIST;
(function (CHILD_ITEM_TYPE_LIST) {
    CHILD_ITEM_TYPE_LIST["SAAL"] = "SAAL";
    CHILD_ITEM_TYPE_LIST["FREEBIE_ATTACH"] = "FREEBIE";
})(CHILD_ITEM_TYPE_LIST || (CHILD_ITEM_TYPE_LIST = {}));
const Exchange = {
    SubTitle(props) {
        const { exchangeViewData } = props;
        if (!exchangeViewData || isEmpty(exchangeViewData) || !exchangeViewData.itemDesc) {
            return null;
        }
        return <span className={styles['subtitle']}>{exchangeViewData.itemDesc}</span>;
    },
    ChecksMessage(props) {
        const { exchangeViewData } = props;
        if (!exchangeViewData || isEmpty(exchangeViewData) || !exchangeViewData.verticalCheck) {
            return null;
        }
        const params = {
            verticalKey: exchangeViewData.verticalKey || ''
        };
        return (<div className={styles['check']}>
				{exchangeViewData.verticalCheck}

				{exchangeViewData.ctaText && exchangeViewData.verticalKey ? (<Help text={exchangeViewData.ctaText} position="bottom-right" className={styles['help-cta']} wrapperClassName={styles['help-wrapper']} onClick={trackHelpOpen}>
						{params.verticalKey ? <KnowMoreContent params={params} key={exchangeViewData.verticalKey}/> : null}
					</Help>) : null}
			</div>);
    }
};
const Error = {
    shouldShow: (childItem) => {
        if (isEmpty(childItem)) {
            return false;
        }
        const itemTag = get(childItem, 'itemTag');
        const itemState = childItem.cartItemState || childItem.checkoutItemState;
        if ((itemTag && itemTag.length) || itemState === CartItemState.COLD_STATE) {
            return true;
        }
        return false;
    },
    Message: (props) => {
        const { childItem } = props;
        if (isEmpty(childItem)) {
            return null;
        }
        const itemTag = get(childItem, 'itemTag');
        const itemState = childItem.cartItemState || childItem.checkoutItemState;
        if (itemTag && itemTag.length) {
            return <span className={styles['abb-oos']}>{itemTag}</span>;
        }
        if (itemState === CartItemState.COLD_STATE) {
            return <StringWidget strKey="cartOutOfStock" className={styles['abb-oos']}/>;
        }
        return null;
    }
};
export function ChildItem(props) {
    var _a;
    const { childItem, handleRemoveChildItem } = props;
    if (isEmpty(childItem)) {
        return null;
    }
    const childItemListingId = get(childItem, 'listingId', '');
    const childItemType = get(childItem, 'childItemType');
    const exchangeViewData = childItem.exchangeViewData;
    const cardPricingDetails = childItem.cardPricingDetails;
    // TODO: If the image doesn't load, the margin has to be removed. Not
    // entirely sure if it's a valid usecase as of now.
    const { imageUrl = placeholder, pricingInfo } = childItem;
    const coinApplied = get(pricingInfo, 'coinApplied');
    const prices = get(cardPricingDetails, 'prices', []);
    const message = get(cardPricingDetails, 'message', []);
    const showPrice = get(cardPricingDetails, 'showPrice', false);
    const coinPrice = coinApplied && prices && prices.find(price => price.priceType === PriceType.COIN_PRICE);
    const slaMessageList = get(childItem, 'itemPromiseInfo.availablePromises', []);
    const appliedCoinPrice = get(coinPrice, 'multiCurrencyPrice');
    const alternateCoinPrice = get(cardPricingDetails, 'coinPrice');
    const itemAnnouncements = get(childItem, 'itemAnnouncements');
    return (<div className={styles['item-wrapper']}>
			<div className={cx(styles['box'], styles['with-border'], styles['left'])}>
				{!(childItemType === CHILD_ITEM_TYPE_LIST.FREEBIE_ATTACH) ? (<img src={removeIcn} width="20px" height="20px" className={styles['remove-icon']} onClick={() => handleRemoveChildItem(childItemListingId, childItemType)}/>) : null}

				<img src={imageUrl} height="72px" width="72px" className={styles['main-img']}/>

				<div className={styles['remove-box']}>
					<p className={styles['title']}>{childItem.mainTitle}</p>
					<Exchange.SubTitle exchangeViewData={exchangeViewData}/>

					{Error.shouldShow(childItem) ? (<Error.Message childItem={childItem}/>) : (<React.Fragment>
							{coinPrice && (<PlusPrice plusPriceInfo={appliedCoinPrice} plusPriceClass={styles['plus-price-bold']} imageSize={18}/>)}
							{childItemType === CHILD_ITEM_TYPE_LIST.SAAL && !showPrice ? null : (<CartItemCardPriceInfo details={cardPricingDetails} showZeroValPrice={childItemType === CHILD_ITEM_TYPE_LIST.FREEBIE_ATTACH}/>)}
							{childItemType === CHILD_ITEM_TYPE_LIST.FREEBIE_ATTACH ? (<span className={styles['freebie-free-text']}>{stringTemplate('free')}</span>) : null}
							<CartOffer cartItem={childItem}/>
							{!coinApplied && <PlusPrice plusPriceInfo={alternateCoinPrice} plusPriceClass={styles['plus-price']}/>}
							<Exchange.ChecksMessage exchangeViewData={exchangeViewData}/>
							{childItemType === CHILD_ITEM_TYPE_LIST.SAAL && slaMessageList.length > 0 && (<ul className={styles['message-list']}>
									{slaMessageList.map(item => {
        return <li className={styles['message-list-item']}>{get(item, 'slaMessage')}</li>;
    })}
									{!showPrice &&
        message.map(item => {
            return <li className={styles['message-list-item']}>{item}</li>;
        })}
								</ul>)}
							{itemAnnouncements ? (<ul className={styles['message-list']}>
									{(_a = itemAnnouncements.map) === null || _a === void 0 ? void 0 : _a.call(itemAnnouncements, item => {
        return <li className={styles['message-list-item']}>{get(item, 'message')}</li>;
    })}
								</ul>) : null}
						</React.Fragment>)}
				</div>
			</div>

			<div className={styles['right']}>
				<PickupCharge pricingInfo={pricingInfo}/>
			</div>
		</div>);
}
export function ChildItems(props) {
    const { items } = props, rest = __rest(props, ["items"]);
    if (isEmpty(items) || !items.length) {
        return null;
    }
    return (<React.Fragment>
			{items.map((childItem, idx) => {
        const childItemListingId = get(childItem, 'listingId', '');
        const key = `${childItemListingId}_${idx}`;
        return <ChildItem {...rest} childItem={childItem} key={key}/>;
    })}
		</React.Fragment>);
}
